import fbIcon from 'assets/icons/fb.svg';
import twitterIcon from 'assets/icons/twitter.svg';
import React, { memo } from 'react';
import socialConstructor from 'utils/socialUrlConstructor';
import { SocialContainer, StyledLink } from './styles/ShareWidgetStyled';

const iconsParams = new Map([
  [
    'fb',
    {
      iconName: fbIcon,
      bg: '#3D51B4',
      size: 22,
    },
  ],
  [
    'twitter',
    {
      iconName: twitterIcon,
      bg: '#000000',
      size: 21,
    },
  ],
]);

const SocialIcons = ({ socials, shareLink, shareText }) => (
  <SocialContainer>
    {socials.map((itemName) => {
      const icon = iconsParams.get(itemName);
      return (
        <StyledLink
          key={itemName}
          type="social"
          background={icon.bg}
          iconName={icon.iconName}
          iconColor="#ffffff"
          iconSize={24}
          href={socialConstructor(itemName, shareLink, shareText)}
        />
      );
    })}
  </SocialContainer>
);

export default memo(SocialIcons);
